export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Informational).8f435961.jpg";